import { render, staticRenderFns } from "./Solan.vue?vue&type=template&id=2007a211&scoped=true&"
import script from "./Solan.vue?vue&type=script&lang=ts&"
export * from "./Solan.vue?vue&type=script&lang=ts&"
import style0 from "./Solan.vue?vue&type=style&index=0&id=2007a211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007a211",
  null
  
)

export default component.exports